import { AuthenticatedLayout } from "@components/layouts/AuthenticatedLayout";
import { CanceledDocumentsView } from "@containers/canceled/CanceledDocumentsView";

const CanceledSessionsPage = () => {
    return (
        <AuthenticatedLayout activeMenuItem="canceledDocuments">
            <CanceledDocumentsView />
        </AuthenticatedLayout>
    );
}

export default CanceledSessionsPage;